import getConfig from 'next/config';

import { hasItem } from '@sravni/ugc/lib/specialOffers/helpers';
import { BUSINESS_OFFERS_LIST, COMMON_OFFERS, EDUCATION_OFFERS } from '@sravni/ugc/lib/specialOffers/lists';
import type { OFFERS_TYPE } from '@sravni/ugc/lib/specialOffers/types';

import type { IOfferOrganization } from '../interfaces/offers';
import { isServer } from '../utils/isServer';

import { getProductData } from './getProductData';

const baseUrl = isServer ? process.env.WEB_PATH : getConfig().publicRuntimeConfig.webPath;

interface GetEducationLinksParams {
  item: any;
}

export const getEducationLinks = ({ item }: GetEducationLinksParams): { viewOfferUrl: URL; clickOfferUrl: URL } => {
  const { advertising, link, hasOffersUrlId } = item;

  let viewOfferUrl = new URL(baseUrl);
  let clickOfferUrl = new URL(baseUrl);

  const clickBaseUrl = advertising.monetization.pixels.click;
  const viewBaseUrl = advertising.monetization.pixels.display;

  try {
    if (clickBaseUrl.includes('url_id=')) {
      clickOfferUrl = new URL(`${clickBaseUrl}${hasOffersUrlId}`);
      viewOfferUrl = new URL(`${viewBaseUrl}${hasOffersUrlId}`);
    } else if (clickBaseUrl.includes('url=')) {
      clickOfferUrl = new URL(`${clickBaseUrl}${link}`);
      viewOfferUrl = new URL(`${viewBaseUrl}${link}`);
    } else if (clickBaseUrl.includes('aff_unique3=')) {
      clickOfferUrl = new URL(`${clickBaseUrl}${link}`);
      viewOfferUrl = new URL(`${viewBaseUrl}${link}`);
    }
  } catch (error) {
    console.error(error);
  }

  return {
    viewOfferUrl,
    clickOfferUrl,
  };
};

interface GetOffersLinksParams {
  type: OFFERS_TYPE;
  item: any;
  utmParams: Record<string, string>;
  organization: IOfferOrganization;
}

export const getProductLinks = ({ item, organization, type, utmParams }: GetOffersLinksParams) => {
  let viewOfferUrl = new URL(baseUrl);
  let clickOfferUrl = new URL(baseUrl);

  if (type === EDUCATION_OFFERS.learning) {
    ({ viewOfferUrl, clickOfferUrl } = getEducationLinks({ item }));
  } else {
    const { ad, advertising, url, alias } = item;
    const advertisingInfo = ad || advertising;
    const hasAdvertising = advertisingInfo?.monetization?.pixels;
    const isCard = type === COMMON_OFFERS.creditCards || type === COMMON_OFFERS.debitCards;

    if (!hasAdvertising) {
      let clickUrl = '';

      const productInfo = getProductData(type);

      if (isCard) {
        clickUrl = url;
      } else if (productInfo.linkToOneProduct) {
        clickUrl = `/bank/${organization.alias}/${productInfo.linkToOneProduct}/${alias}/`;
      } else if (hasItem(BUSINESS_OFFERS_LIST, type)) {
        clickUrl = productInfo.generalLink;
      } else {
        clickUrl = productInfo.generalLink;
      }
      return { clickUrl };
    }

    try {
      viewOfferUrl = new URL(advertisingInfo.monetization.pixels.display);
      clickOfferUrl = new URL(advertisingInfo.monetization.pixels.click);
    } catch (error) {
      console.error(error);
    }
  }

  Object.entries(utmParams).forEach(([key, value]) => {
    viewOfferUrl.searchParams.set(key, value);
    clickOfferUrl.searchParams.set(key, value);
  });

  return {
    viewUrl: viewOfferUrl.toString(),
    clickUrl: clickOfferUrl.toString(),
  };
};
